import { css } from '@emotion/css'

export const iframeContainer = css`
  width: 100%;
  height: 460px;
  border: none;
  margin: 0;
  border: 0px;
`
